module.exports = __webpack_public_path__ + "static/media/snfoods.ad02ae0d.png";